import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Paper,
  Typography,
} from '@material-ui/core';

import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


const newsitem = (props) => {
  let classNames = [classes.card];
  if (props.showCaption) {
    classNames.push(classes.sidebarItem);
  }
  if (props.homeItem) {
    classNames = [classes.card, classes.cardHomeItem];
  } else {
    classNames = [classes.card, classes.cardFancy];
  }
  return (
    <Link className={classes.linkDeCSS} to={formatRoute(routes.NEWS_DETAIL, { slug: props.slug })}>
      <Paper className={classNames.join(' ')} style={{ marginBottom: '10px' }} align="left">
        {props.showCaption ? <Typography variant="caption" style={{ fontSize: '16px' }}>News</Typography> : null}
        <Typography variant="title" style={{ marginBottom: '10px' }}>{props.title}</Typography>
        <Typography variant="body1">{props.summary}</Typography>
      </Paper>
    </Link>
  );
};

export default newsitem;



// WEBPACK FOOTER //
// ./src/main/components/NewsListItem.js